import React from "react";

const MAP = {
  high: { bg: "#ECFDF5", text: "#065F46", border: "#A7F3D0", label: "High Confidence" },
  medium: { bg: "#FFFBEB", text: "#92400E", border: "#FDE68A", label: "Medium Confidence" },
  low: { bg: "#FEF2F2", text: "#991B1B", border: "#FECACA", label: "Low Confidence" },
  insufficient: { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB", label: "Insufficient Data" },
};

export function ConfidenceBadge({ level, label, testId }) {
  const c = MAP[level] || MAP.insufficient;
  return (
    <span
      data-testid={testId || `confidence-badge-${level}`}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold"
      style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.text }} />
      {label || c.label}
    </span>
  );
}
